<template>
  <el-dialog
    :title="title"
    :visible.sync="isEdit"
    :close-on-click-modal="false"
    @close="close"
  >
    <el-form
      ref="fForm"
      :model="ruleForm"
      size="small"
      :rules="rules"
      label-width="130px"
    >
      <el-row>
        <el-col>
          <el-form-item class="scale" label=" APP是否展示：" required>
            <el-radio-group v-model="ruleForm.isApp">
              <el-radio
                v-for="item in publicData"
                :key="item.paramKey"
                :label="Number(item.paramKey)"
                >{{ item.paramValue }}</el-radio
              >
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item class="scale" label=" WEB是否展示：" required>
            <el-radio-group v-model="ruleForm.isWeb">
              <el-radio
                v-for="item in publicData"
                :key="item.paramKey"
                :label="Number(item.paramKey)"
                >{{ item.paramValue }}</el-radio
              >
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item class="scale" label=" 小程序是否展示：" required>
            <el-radio-group v-model="ruleForm.isApplet">
              <el-radio
                v-for="item in publicData"
                :key="item.paramKey"
                :label="Number(item.paramKey)"
                >{{ item.paramValue }}</el-radio
              >
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item class="scale" label=" PC端是否展示：" required>
            <el-radio-group v-model="ruleForm.isPc">
              <el-radio
                v-for="item in publicData"
                :key="item.paramKey"
                :label="Number(item.paramKey)"
                >{{ item.paramValue }}</el-radio
              >
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item class="scale" label="封面：" prop="coverUrl">
            <div
              v-if="ruleForm.coverUrl"
              id="video-output"
              @mouseenter="showCover = true"
              @mouseleave="showCover = false"
            >
              <img :src="ruleForm.coverUrl" class="avatar" />
              <div v-show="showCover" class="cover-bg">
                <i
                  class="el-icon-zoom-in delete"
                  @click.stop="showViewer = true"
                ></i>
                <i class="el-icon-delete delete" @click.stop="deleteCover"></i>
              </div>
            </div>
            <el-upload
              v-else
              action=""
              class="avatar-uploader"
              :show-file-list="false"
              :http-request="uploadCover"
              accept="png,jpg,jpeg"
              :limit="1"
              ref="coverUpload"
            >
              <i class="el-icon-plus avatar-uploader-icon"></i>
              <label v-if="!ruleForm.coverUrl" class="upload-text"
                >上传图片</label
              >
            </el-upload>
            <div class="img_tip">建议尺寸：315px*420px（或3:4）</div>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item label="图书名称：" prop="bookName">
            <el-input
              placeholder="请输入图书名称"
              v-model="ruleForm.bookName"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item
            label="图书来源："
            prop="bookSource"
            :rules="[{ required: true, message: '请输入图书来源' }]"
          >
            <el-input
              type="imput"
              placeholder="请输入图书来源"
              v-model="ruleForm.bookSource"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item label="图书作者：" prop="bookAuthor">
            <el-input
              placeholder="请输入图书作者"
              v-model="ruleForm.bookAuthor"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <el-form-item label="图书分类：" prop="categoryId" required>
            <el-cascader
              class="form-select"
              v-model="ruleForm.categoryId"
              :options="categoryData"
              :props="{ label: 'name', value: 'id', children: 'children' }"
            >
            </el-cascader>
            <!-- <el-select
              v-model="ruleForm.categoryId"
              placeholder="请选择图书分类"
              class="form-select"
            >
              <el-option
                v-for="item in categoryData"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select> -->
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <el-form-item label="有效期：" prop="expireTime" required>
            <el-date-picker
              class="form-select"
              type="date"
              placeholder="选择日期"
              v-model="ruleForm.expireTime"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              :picker-options="expireTimeOption"
              :rules="[{ required: true, message: '请选择有效期' }]"
            ></el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item label="长简介：">
            <el-input v-model="ruleForm.bookLongDesc"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <butn @click="isEdit = false" title="取消"></butn>
      <butn btntype="primary" @click="updateForm" title="确定"></butn>
    </div>
    <!-- 图片预览 -->
    <el-image-viewer
      v-if="showViewer"
      :on-close="closeViewer"
      :url-list="[ruleForm.coverUrl]"
    />
  </el-dialog>
</template>

<script>
import { getSysParamByTypes } from "@/api/sysParam";
import butn from "@/components/button/index";
import FileHandler from "@/utils/file";
import vue from "@/main";
import { bookInfo, bookUpdate } from "@/api/book";
import { resCategoryTree } from "@/api/rescategory";
import ElImageViewer from "element-ui/packages/image/src/image-viewer";
import moment from "moment";
import { findTrackById } from "@/utils/shared";

export default {
  name: "update",
  components: { butn, ElImageViewer },
  data() {
    return {
      publicData: [],
      isEdit: false,
      title: "图书编辑",
      categoryData: [],
      ruleForm: {
        uuid: "",
        coverUrl: "",
        bookName: "",
        bookSource: "",
        bookAuthor: "",
        categoryId: "",
        expireTime: null,
        bookLongDesc: "",
        isApplet: "",
        isApp: "",
        isWeb: "",
      },
      showViewer: false,
      showCover: false,
      expireTimeOption: {
        disabledDate(date) {
          return (
            date.getTime() < new Date(moment().format("YYYY-MM:DD")).getTime()
          );
        },
      },
      rules: {
        coverUrl: [
          {
            required: true,
            message: "请上传图片",
            trigger: ["blur", "change"],
          },
        ],
        bookName: [
          {
            required: true,
            message: "请输入图书名称",
            trigger: ["blur", "change"],
          },
        ],
        bookAuthor: [
          {
            required: true,
            message: "请输入图书作者",
            trigger: ["blur", "change"],
          },
        ],
        categoryId: [
          {
            required: true,
            message: "请选择图书分类",
            trigger: ["blur", "change"],
          },
        ],
        expireTime: [
          {
            required: true,
            message: "请选择有效期",
            trigger: ["blur", "change"],
          },
        ],
      },
    };
  },
  methods: {

    show(uuid) {
      bookInfo(uuid).then((res) => {
        if (!res || res.code !== 0) return;
        const item = res.data;
        this.ruleForm.uuid = item.uuid;
        this.ruleForm.coverUrl = item.coverUrl;
        this.ruleForm.bookName = item.bookName;
        this.ruleForm.bookSource = item.bookSource;
        this.ruleForm.bookAuthor = item.bookAuthor;
        this.ruleForm.categoryId = item.categoryId;
        this.ruleForm.expireTime = item.expireTime;
        this.ruleForm.bookLongDesc = item.bookLongDesc;
        this.ruleForm.isApp = item.isApp;
        this.ruleForm.isWeb = item.isWeb;
        this.ruleForm.isApplet = item.isApplet;
        this.ruleForm.isPc = item.isPc;
        this.isEdit = true;
        if (
          this.ruleForm.categoryId &&
          this.categoryData &&
          this.categoryData.length
        ) {
          const track = findTrackById(
            this.categoryData,
            this.ruleForm.categoryId,
            "id"
          );
          if (track && track.length) {
            this.ruleForm.categoryId = track;
          }
        }
      });
    },
    // 获取多个数据字典
    getSysParamByTypes(types) {
      getSysParamByTypes({ types: types }).then((res) => {
        if (!res || res.code != 0) return;
        this.publicData = res.data["IS_VALID"] || [];
      });
    },
    closeViewer() {
      this.showViewer = false;
    },
    deleteCover() {
      this.ruleForm.coverUrl = "";
    },
    async uploadCover(e) {
      let file = e.file;
      // 校验文件格式是否符合要求(png格式或者jpg格式)
      const image = await FileHandler.isImage(file);
      if (!image) {
        this.$message({
          message: "请上传格式为png、jpg格式的文件，其余文件格式无法上传哦！",
          type: "warning",
        });
        // 重点: 异常流程时必须要清除上传的文件，否则设置限制文件上传数量为1时不能再次执行上传事件
        this.$refs["coverUpload"].clearFiles();
        return;
      }
      FileHandler.uploadFile(`book/img`, file).then((res) => {
        const { url } = res;
        this.ruleForm.coverUrl = url;
      });
    },
    close() {
      // 点击取消 数据重置
      this.isEdit = false;
      this.$refs["fForm"].resetFields();
    },
    updateForm() {
      if (
        this.ruleForm.isApplet == "0" &&
        this.ruleForm.isApp == "0" &&
        this.ruleForm.isWeb == "0" &&
        this.ruleForm.isPc == "0"
      ) {
        this.$message({
          message: "请至少选择一个终端展示!",
          type: "warning",
        });
        return;
      }
      this.$refs["fForm"].validate((valid) => {
        if (valid) {
          const params = Object.assign(this.ruleForm);
          if (params.categoryId && params.categoryId.length > 0) {
            params.categoryId = params.categoryId[params.categoryId.length - 1];
          }
          bookUpdate(params).then((res) => {
            if (!res || res.code !== 0) return;
            this.$message({
              message: "操作成功！",
              type: "success",
            });
            this.$emit("initTable");
            this.close();
          });
        }
      });
    },
  },
  created() {
    this.getSysParamByTypes(["IS_VALID"]);
    // 获取视频分类数据
    resCategoryTree({
      categoryType: 1,
      display: 1,
    }).then((res) => {
      if (!res || res.code !== 0) return;
      this.categoryData = res.data || [];
    });
  },
};
</script>

<style lang="scss" scoped>
$textColor: #51627d;
$textSize: 14px;
.avatar-uploader /deep/ .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  background-color: #f7f9fc;
  width: 160px;
  height: 160px;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 70px;
  height: 70px;
  line-height: 70px;
  text-align: center;
}

.avatar {
  width: 160px;
  height: 160px;
  display: block;
  object-fit: contain;
}

.upload-text {
  color: $textColor;
  font-size: 13px;
}

#video-output {
  width: 160px;
  height: 160px;
  position: relative;

  .cover-bg {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(1, 1, 1, 0.5);
    z-index: 199;
    display: flex;
    justify-content: space-evenly;
    align-items: center;
    color: #ffffff;

    .delete {
      font-size: 20px;
      cursor: pointer;
    }
  }
}

.upload_tip {
  width: 160px;
  text-align: center;
  margin-top: 10px;
}

.upload_tip p {
  font-size: 14px;
  margin: 0;
  line-height: 30px;
  color: #51627d;
}

.upload_tip p.img_tip {
  font-size: 12px;
  color: #96a1b2;
}
</style>
